!function(window) {

document.querySelectorAll(".language-dropdown .dropdown-item").forEach(lang =>
	lang.addEventListener("click", function(e){
		localStorage.setItem('selectedLang', this.dataset.langshort);
	})
);

}.call(window, window);